import React from 'react'
import Link from 'gatsby-link'

import Footer from '../components/footer'

const Imprint = () => (
  <div className="Imprint">
      <div className="ImprintInner">
        <h1>Impressum</h1>
        <h2>Diensteanbieter</h2>
        <p>Irina Koepp<br/>
          MutterKindPflege<br/>
          Maximilianstr. 12<br/>
          Deutschland<br/>
          Institutionskennzeichen (IK): 463101872</p>
        <h2>Kontaktmöglichkeiten</h2>
        <p>E-Mail-Adresse: <a href="mailto:info@mutterkindpflege.berlin">info@mutterkindpflege.berlin</a></p>
        <p>Telefon: +49 176 72469682</p>
        <h2>Berufshaftpflichtversicherung</h2>
        <p>AXA</p>
        <p>Versicherung AG</p>
        <p>Postfach 92 03 01</p>
        <p>51153 Köln</p>
        <p>Räumliche Geltung: Deutschland</p>
        <h2>Haftungs- und Urheberrechtshinweise</h2>
        <p>Links auf fremde Webseiten: Inhalte fremder Webseiten, auf die wir direkt oder indirekt verweisen, liegen außerhalb meines Verantwortungsbereiches und mache ich mir nicht zu Eigen. Für alle Inhalte und insbesondere für Schäden, die aus der Nutzung der in den verlinkten Webseiten aufrufbaren Informationen entstehen, haftet allein der Anbieter der verlinkten Webseiten.</p>
        <h2>Bildnachweise</h2>
        <p>Bildquellen und Urheberrechtshinweise:<br/>
          ©Felix Koepp</p>
        <p>Design & Implementierung:</p>
        <a href="http://felix-koepp.com">felix-koepp.com</a>
        <div className="ImprintEnd">
          <Link to="/">Zurück zur Website</Link><br/>
        </div>
      </div>
    <Footer />
  </div>
)

export default Imprint


// WEBPACK FOOTER //
// ./src/pages/imprint.js